import { useQuery } from '@tanstack/react-query';

import { getAddressAutoComplete } from '@/app/queries';

const useAddressLookup = <T>(query: string) => {
  const addressListQuery = useQuery({
    queryKey: ['addressAutoComplete', { query }],
    queryFn: getAddressAutoComplete,
    retry: false,
  });

  const { data } = addressListQuery as { data?: { matches?: T[] } };

  const list = data?.matches ?? [];

  return { ...addressListQuery, data: list };
};

export { useAddressLookup };
